import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsEN from './en.json';
import translationsDA from './da.json';
import translationsDE from './de.json';
import translationsPL from './pl.json';

export const resources = {
  en: { translations: translationsEN },
  da: { translations: translationsDA },
  de: { translations: translationsDE },
  pl: { translations: translationsPL },
};

const getLanguage = (): string => {
  const language = navigator.language;
  switch (language) {
    case 'da-DK':
      return 'da';
    case 'en-US':
    case 'en-CA':
      return 'en';
    case 'de-AT':
    case 'de-DE':
    case 'de-CH':
      return 'de';
    case 'pl-PL':
      return 'pl';
    default:
      return language;
  }
};

const getLanguagePart = (language: string) => {
  // ISO 639-1Browser language "da", "en", "de", "da-DK", "en-GB" etc. to
  // language part e.g. "da", "en", "de"
  return language.split('-')[0];
};

export const apiTranslate = (translations: Record<string, string>): string => {
  // We currently pick the first translation
  // TODO: DHM: Pick the correct translation depending on users language
  if (!translations || Object.entries(translations).length === 0) {
    return '';
  }

  const language = getLanguagePart(navigator.language);

  const translateKeys = Object.keys(translations);

  const matchWithUserLanguage = translateKeys.find(
    (key) => getLanguagePart(key) === language,
  );

  if (matchWithUserLanguage) {
    return translations[matchWithUserLanguage] ?? '';
  }

  return translations[translateKeys[0]] ?? '';
};

i18n.use(initReactI18next).init({
  lng: getLanguage(),
  fallbackLng: 'en',
  ns: ['translations'],
  resources,
});
